/**
 * @param  {HTMLElement} element button
 * @return {void}
 */
function toggleButton(element) {
  // Check to see if the button is pressed
  const pressed = (element.getAttribute('aria-pressed') === 'true');
  // Change aria-pressed to the opposite state
  element.setAttribute('aria-pressed', !pressed);
}

/**
 * @param  {Event} event click event
 * @return {void}
 */
function handleBtnClick(event) {
  toggleButton(event.target);
}

/**
 * @param  {Event} event key press event
 * @return {void}
 */
function handleBtnKeyPress(event) {
  // Check to see if space or enter were pressed
  if (event.key === ' ' || event.key === 'Enter') {
    // Prevent the default action to stop scrolling when space is pressed
    event.preventDefault();
    toggleButton(event.target);
  }
}

/**
 * @param  {HTMLElement} element label
 * @return {void}
 */
function toggleLabel(element) {
  const label = element;
  const alternativeText = label.dataset.text;
  const currentText = label.innerHTML;

  // replace text
  label.innerHTML = alternativeText;

  // replace data
  label.dataset.text = currentText;
}

/**
 * @param  {HTMLElement} scope = document
 * @return {void}
 */
export default function initToggleButtons(scope = document) {
  const buttons = [].slice.call(scope.querySelectorAll('[aria-pressed]'));

  buttons.forEach((button) => {
    // on click
    button.addEventListener('click', (event) => {
      const labelWithAlternativeText = button.querySelector('[data-text]');

      // toggle button
      handleBtnClick(event);

      // change label if alternative label is provided
      if (labelWithAlternativeText) {
        toggleLabel(labelWithAlternativeText);
      }
    });

    // on key press
    button.addEventListener('keyPress', (event) => {
      handleBtnKeyPress(event);
    });
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/toggleButton.js